import { render, staticRenderFns } from "./sb-ad.vue?vue&type=template&id=54249280&scoped=true&"
import script from "./sb-ad.vue?vue&type=script&lang=js&"
export * from "./sb-ad.vue?vue&type=script&lang=js&"
import style0 from "./sb-ad.vue?vue&type=style&index=0&id=54249280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54249280",
  null
  
)

export default component.exports